var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "proposal-evaluation-document row" }, [
    _c(
      "div",
      { staticClass: "col-12 px-0" },
      [
        _c(
          "callout",
          {
            attrs: {
              controlled: true,
              "has-border": false,
              "has-gradient": "",
              "has-toggle": "",
              opened: _vm.isCalloutOpen
            },
            on: { "click:open": _vm.showDocuments }
          },
          [
            _c("div", { staticClass: "header" }, [
              _c("span", [_vm._v(_vm._s(_vm.title))])
            ]),
            _c(
              "div",
              {
                staticClass: "document-container",
                attrs: { slot: "edition" },
                slot: "edition"
              },
              [
                _vm._l(_vm.page.data, function(document, idx) {
                  return _c(
                    "div",
                    { key: idx, staticClass: "document-container__element" },
                    [
                      _c("document-info", {
                        attrs: { "bg-color": "white", document: document }
                      })
                    ],
                    1
                  )
                }),
                _vm.page.totalItemCount > _vm.pageSize
                  ? _c("pagination", {
                      attrs: { data: _vm.page, "page-size": _vm.pageSize },
                      on: { "pagination-go-page": _vm.setCurrentPage }
                    })
                  : _vm._e()
              ],
              2
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }